import React from 'react';

// import Title from './../../partials/Title';

const ReleaseNotes = () => {
	return (
		<div>
			<div className="top-header bg-white">
				<div className="release-page-title pb-2"></div>
			</div>
			<div className="release-ModalContainer container-fluid">
				<div className="notes-header">
					<h3 className="gray_dark_01 weight-600 regular-32 p-0 m-0">What’s new?</h3>
					<p className="gray_dark_01 regular-16 pt-1">
						Release Notes on all updates, new features, and improvements of our platform
					</p>
				</div>

				<div className="all-release-notes mt-3 mb-4">
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">April 2025 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made improvements to enhance{' '}
											<span className="weight-600 gray_dark_01">Virtual Try-On</span>{' '}
											accuracy
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												Introduced set products in Folder
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">March 2025 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Revamped system architecture to support performance and
											scalability improvements
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released{' '}
											<span className="weight-600 gray_dark_01">
												Sample Inventory version 2,
											</span>
											including mobile sample scanning and a mobile version of Techpack
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced{' '}
											<span className="weight-600 gray_dark_01">
												Factory Purchase Orders
											</span>{' '}
											and streamlined{' '}
											<span className="weight-600 gray_dark_01"> Repeat Order </span>{' '}
											functionality
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched the{' '}
											<span className="weight-600 gray_dark_01">
												first version of Virtual Try-On
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">February 2025 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Enhanced the{' '}
											<span className="weight-600 gray_dark_01">
												Design Publish Journey
											</span>{' '}
											with improved product development status tracking and filters{' '}
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Upgraded{' '}
											<span className="weight-600 gray_dark_01">
												Material Management
											</span>{' '}
											with add/delete history in Techpack, fabric-color-pattern
											matching, and bulk upload capabilities
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">January 2025 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Upgraded the PDF generation library in the
											<span className="weight-600 gray_dark_01"> pyutils </span>
											project for efficient and pixel perfect PDF generation
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Integrated a service to push{' '}
											<span className="weight-600 gray_dark_01">
												Development Tracker data
											</span>{' '}
											from system notification into
											<span className="weight-600 gray_dark_01">
												{' '}
												Metabase reports{' '}
											</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Enabled
											<span className="weight-600 gray_dark_01">
												AI-powered search{' '}
											</span>
											in the
											<span className="weight-600 gray_dark_01"> Fabric Library </span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">December 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Enhanced
											<span className="weight-600 gray_dark_01">
												{' '}
												Favourite Folder{' '}
											</span>
											and
											<span className="weight-600 gray_dark_01"> Range Planning </span>
											workflows
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Added filters in Favourite Folder details and Collection details
											for better navigation and management
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">November 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Incorporated user feedback into the
											<span className="weight-600 gray_dark_01">
												{' '}
												Supplier Platform{' '}
											</span>
											and
											<span className="weight-600 gray_dark_01">
												Admin Panel supplier profile,
											</span>{' '}
											alongside several enhancements to the material list
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced the
											<span className="weight-600 gray_dark_01">
												{' '}
												Favourite Folder{' '}
											</span>
											feature in the Admin Panel, allowing to link multiple collections
											Favourite Folder within a folder, the ability to create and
											<span className="weight-600 gray_dark_01">
												presentation links,
											</span>{' '}
											and launched the
											<span className="weight-600 gray_dark_01"> Range Planning </span>
											tool for both collections and folders
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">October 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01"> the Trend </span>
											to assist our designers and account managers
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released{' '}
											<span className="weight-600 gray_dark_01">
												Sample inventory version{' '}
											</span>
											1 enbling sample tracking via QR code
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												{' '}
												Released P&C Buyer Pricing{' '}
											</span>
											–designed to display real-time updated design prices in the Buyer
											Panel for P&C buyers, added new filters for the Design List and
											Collection List across both Collection and Nitex Studio menus, and
											introduced a review process for Nitex Studio design costing.
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												Implemented Mixpanel Events Tracking
											</span>{' '}
											in buyer panel – offering enhanced insights into user behavior for
											more informed decision-making.
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">September 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released{' '}
											<span className="weight-600 gray_dark_01">Factory TNA</span> to
											streamline TNA creation process through excel upload, along with
											several enhancements to the overall{' '}
											<span className="weight-600 gray_dark_01">TNA module</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">August 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Implemented improvements{' '}
											<span className="weight-600 gray_dark_01">
												Collection and design list{' '}
											</span>
											to facilitate the pick-and-choose process
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched the{' '}
											<span className="weight-600 gray_dark_01">
												Sketch & Artwork Library{' '}
											</span>
											for asset management
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">July 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced
											<span className="weight-600 gray_dark_01">
												Sales Funnel Target{' '}
											</span>{' '}
											and
											<span className="weight-600 gray_dark_01">
												{' '}
												CRM Dashboard
											</span>{' '}
											for better tracking and insights
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released the
											<span className="weight-600 gray_dark_01"> POM Library</span> with
											category/subcategory-specific measurement templates
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Added a new filter in the
											<span className="weight-600 gray_dark_01"> Fabric List</span> and
											made several improvements in
											<span className="weight-600 gray_dark_01"> Collection </span> and
											<span className="weight-600 gray_dark_01"> Techpack</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												Launched the Block Library,{' '}
											</span>{' '}
											designed to be used as a{' '}
											<span className="weight-600 gray_dark_01">
												measurement template{' '}
											</span>{' '}
											for quick and efficient
											<span className="weight-600 gray_dark_01">
												measurement chart creation{' '}
											</span>
											based on the template
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">June 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made improvements to the
											<span className="weight-600 gray_dark_01"> My Profile </span>{' '}
											section and implemented the
											<span className="weight-600 gray_dark_01">My Colleague</span>
											page, designed to enhance collaboration and help users easily
											identify the right person for any task or inquiry.
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched the
											<span className="weight-600 gray_dark_01">
												{' '}
												Turkey Material Inventory
											</span>{' '}
											and made several improvements to the
											<span className="weight-600 gray_dark_01">
												{' '}
												Material List
											</span>{' '}
											page
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											{' '}
											Released a new version of the
											<span className="weight-600 gray_dark_01">
												{' '}
												Measurement Chart,
											</span>{' '}
											including history tracking and restore functionality
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">May 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several improvements in
											<span className="weight-600 gray_dark_01"> Sales Funnel</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">April 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Redesigned
											<span className="weight-600 gray_dark_01"> Sample </span> and
											<span className="weight-600 gray_dark_01"> Costing </span>
											process
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released
											<span className="weight-600 gray_dark_01"> Sales Funnel</span> to
											enhance sales tracking and forecasting
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several improvements in
											<span className="weight-600 gray_dark_01">
												{' '}
												Sales Contracts in Order, Material Library,
											</span>{' '}
											and
											<span className="weight-600 gray_dark_01">
												{' '}
												File Section in Design Tool
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">March 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												Redesigned the Collection View
											</span>{' '}
											to improve usability and organization, introducing features such
											as{' '}
											<span className="weight-600 gray_dark_01">
												tags, stages, and status,
											</span>{' '}
											with multiple view options (large, small, image, list, etc.) and
											enhanced filtering and grouping
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced
											<span className="weight-600 gray_dark_01">
												{' '}
												Set and Pack Style features{' '}
											</span>
											in the collection, adding support for
											<span className="weight-600 gray_dark_01">
												{' '}
												Set Style Sample Requests, Costing Requests,
											</span>{' '}
											and
											<span className="weight-600 gray_dark_01"> Orders</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">February 2024 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												Launched a revamped Supplier Profile,{' '}
											</span>
											providing more detailed information and insights for each supplier
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">December 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Redesigned
											<span className="weight-600 gray_dark_01">
												{' '}
												Measurement Chart{' '}
											</span>
											in design tool
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced
											<span className="weight-600 gray_dark_01"> List View </span> and
											<span className="weight-600 gray_dark_01"> Draft Feature </span>
											in the Buyer Panel favourite folder for improved usability
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">October 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												Further Development in the Buyer Panel{' '}
											</span>
											to enhance user experience and functionality
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">September 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											<span className="weight-600 gray_dark_01">
												Launched New Buyer Panel -{' '}
											</span>
											introduced features like
											<span className="weight-600 gray_dark_01">
												{' '}
												Favourite Folder, Build Your Range, Image Search, Text
												Search,{' '}
											</span>
											and
											<span className="weight-600 gray_dark_01">
												{' '}
												Autogenerated Collections{' '}
											</span>
											for a more streamlined buying experience
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">August 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several improvements to the
											<span className="weight-600 gray_dark_01">
												{' '}
												Material List, Product Materials, and Order Materials
											</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched
											<span className="weight-600 gray_dark_01">
												{' '}
												Trims & Accessories Inventory,{' '}
											</span>
											Introduced
											<span className="weight-600 gray_dark_01">
												{' '}
												Material Stickers{' '}
											</span>
											containing unique QR codes, with download and print options
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced
											<span className="weight-600 gray_dark_01">
												{' '}
												Block Suggestion{' '}
											</span>
											in design tool
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced a
											<span className="weight-600 gray_dark_01"> Files </span>
											section with version management for different file type in design
											tool
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">July 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several improvements in
											<span className="weight-600 gray_dark_01">
												{' '}
												CRM Projections(Target),{' '}
											</span>
											Introduced
											<span className="weight-600 gray_dark_01">
												{' '}
												Dashboard and Global Sales Analyzer{' '}
											</span>
											within the CRM module
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">June 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced first version of
											<span className="weight-600 gray_dark_01">
												{' '}
												Fabric Inventory{' '}
											</span>
											in material library
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released
											<span className="weight-600 gray_dark_01">
												{' '}
												CRM Projection(Target) Flow – Version 2{' '}
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">May 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Rolled out the first version of
											<span className="weight-600 gray_dark_01">
												{' '}
												Techpack Upload (PDF/Image) and Collection Publication Journey
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">April 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released first version of
											<span className="weight-600 gray_dark_01">
												{' '}
												CRM Projection(Target) Flow
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">March 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several Improvements in
											<span className="weight-600 gray_dark_01">
												{' '}
												Order Dashboard and Costing Module
											</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Revamped
											<span className="weight-600 gray_dark_01">
												{' '}
												In-App Notifications{' '}
											</span>
											across both Admin and Buyer panels
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">February 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Several improvements in
											<span className="weight-600 gray_dark_01">
												{' '}
												Collections and Designs{' '}
											</span>
											menu
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced several new processes in order improvement including
											<span className="weight-600 gray_dark_01">
												{' '}
												PI and Sales Contract request flow, order and style
												cancellation process, PI & Sales Contract merge
												functionality{' '}
											</span>
											etc
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">January 2023 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Redesigned the
											<span className="weight-600 gray_dark_01">
												{' '}
												User Access Management{' '}
											</span>
											across the entire platform for improved control and usability
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Revamped
											<span className="weight-600 gray_dark_01">
												{' '}
												Supplier Material{' '}
											</span>
											module
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">December 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released
											<span className="weight-600 gray_dark_01"> Order Dashboard </span>
											for the Order Management team, with a redesigned
											<span className="weight-600 gray_dark_01"> TNA module </span>
											with enhanced task-level communication options
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">November 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Implemented
											<span className="weight-600 gray_dark_01">
												{' '}
												Asynchronous Product Copy{' '}
											</span>
											mechanism in Collections, with real-time status visibility
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Added
											<span className="weight-600 gray_dark_01">
												{' '}
												Advanced Filters{' '}
											</span>
											for Team Leads and new options for Fashion Designers, including
											<span className="weight-600 gray_dark_01">
												Costing and Photoshoot menus
											</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several improvements in
											<span className="weight-600 gray_dark_01"> Costing </span>
											module
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Bug fixes and improvements in
											<span className="weight-600 gray_dark_01">
												{' '}
												Techpack and Design Tool{' '}
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">September 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Redesigned the
											<span className="weight-600 gray_dark_01">
												{' '}
												real-time Communication System{' '}
											</span>
											using websocket
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several improvements in
											<span className="weight-600 gray_dark_01">Design Tool</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Rolled out several enhancements for the
											<span className="weight-600 gray_dark_01">
												{' '}
												Project Management{' '}
											</span>
											team based on user feedback
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">August 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched a
											<span className="weight-600 gray_dark_01">
												{' '}
												revamped Buyer Panel,{' '}
											</span>
											with aligned updates in the Admin Panel—including
											<span className="weight-600 gray_dark_01">
												{' '}
												Buyer Requests, Quotes, Moodboard, and TNA{' '}
											</span>
											modules
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">June 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Add to favourite & play presentation
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced
											<span className="weight-600 gray_dark_01">
												{' '}
												Add to Favourite and Play Presentation{' '}
											</span>
											features in collections
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Sample request module, with photography and initial costing
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched the
											<span className="weight-600 gray_dark_01">
												{' '}
												Sample Request module, Photography{' '}
											</span>
											module, and
											<span className="weight-600 gray_dark_01"> Initial Costing </span>
											module
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">May 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched the
											<span className="weight-600 gray_dark_01"> Design Tool, </span>
											along with several improvements to
											<span className="weight-600 gray_dark_01">
												Techpack and Collections
											</span>
											modules
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">April 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Integrated in the order module
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made system-level improvements, including the removal of
											<span className="weight-600 gray_dark_01">
												{' '}
												Elasticsearch integration{' '}
											</span>
											from the
											<span className="weight-600 gray_dark_01"> Designs </span>
											module
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">March 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced
											<span className="weight-600 gray_dark_01">
												{' '}
												Design Bulk Upload{' '}
											</span>
											and redesigned
											<span className="weight-600 gray_dark_01">
												{' '}
												Design and Collection{' '}
											</span>
											pages
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced our in-house
											<span className="weight-600 gray_dark_01">
												{' '}
												Python-based PDF generation{' '}
											</span>
											library from HTML content, kicking off
											<span className="weight-600 gray_dark_01"> py-utils </span>
											project (formerly html-to-pdf)
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Wrapped up the
											<span className="weight-600 gray_dark_01">
												{' '}
												Complete Order Journey{' '}
											</span>
											with key updates:
											<span className="weight-600 gray_dark_01">
												{' '}
												Commercial Invoice{' '}
											</span>
											module in Admin Panel and
											<span className="weight-600 gray_dark_01"> Order Timeline </span>
											in Buyer Panel
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">February 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Continued the
											<span className="weight-600 gray_dark_01">
												{' '}
												Complete Order Journey (Part 2){' '}
											</span>
											with -
											<span className="weight-600 gray_dark_01">
												{' '}
												Sales Contract, Material List, Team Assignment, and TNA
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">January 2022 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several enhancements to the
											<span className="weight-600 gray_dark_01">
												{' '}
												Collection, Design,{' '}
											</span>{' '}
											and
											<span className="weight-600 gray_dark_01"> Login Journey </span>
											in the
											<span className="weight-600 gray_dark_01"> Buyer Panel </span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">December 2021 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Kicked off
											<span className="weight-600 gray_dark_01">
												{' '}
												Complete Order Journey (Part 1) with Proforma Invoice
												(PI){' '}
											</span>
											tab inside an Order
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">November 2021 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Improved
											<span className="weight-600 gray_dark_01"> Account Manager </span>
											flow in Order management
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced
											<span className="weight-600 gray_dark_01"> Image Crop </span>
											functionality and support for different
											<span className="weight-600 gray_dark_01">
												{' '}
												Product Size Categories{' '}
											</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched
											<span className="weight-600 gray_dark_01">
												{' '}
												Supplier and Material{' '}
											</span>
											modules, along with the
											<span className="weight-600 gray_dark_01">
												{' '}
												first-time integration of Mixpanel{' '}
											</span>
											for event tracking and analytics
										</li>{' '}
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">October 2021 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Redesigned the Product details page - introduced various document
											group:
											<span className="weight-600 gray_dark_01">
												{' '}
												Physical Sample, Flat Sketch, Artwork, and Reference
												Image{' '}
											</span>
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Launched the
											<span className="weight-600 gray_dark_01">
												{' '}
												Costing and Recosting{' '}
											</span>
											modules
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">August 2021 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Released the
											<span className="weight-600 gray_dark_01">
												{' '}
												Presentation Download{' '}
											</span>
											functionality from the system, eliminating the need for a graphic
											designer to manually create presentations
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Introduced the
											<span className="weight-600 gray_dark_01">
												{' '}
												Project Director Dashboard and All Tasks{' '}
											</span>
											pages
										</li>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Made several improvements in
											<span className="weight-600 gray_dark_01">
												{' '}
												Order Management,{' '}
											</span>
											including: New
											<span className="weight-600 gray_dark_01">
												{' '}
												30, 45, and 60-day TNA templates, TNA Download{' '}
											</span>
											option, and
											<span className="weight-600 gray_dark_01">
												{' '}
												Due task reminders via Push Notification and Email{' '}
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">July 2021 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Automated
											<span className="weight-600 gray_dark_01">
												{' '}
												Boohoo PO Data Extraction{' '}
											</span>
											to assist merchandisers in managing Boohoo POs more efficiently
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">June 2021 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02">
											Redesigned
											<span className="weight-600 gray_dark_01">
												{' '}
												Order Management{' '}
											</span>
											by introducing
											<span className="weight-600 gray_dark_01">
												{' '}
												TNA and Critical Path,{' '}
											</span>
											along with
											<span className="weight-600 gray_dark_01">
												{' '}
												Complete, Approve, and Revise{' '}
											</span>
											options for each task. Also added a
											<span className="weight-600 gray_dark_01">
												{' '}
												tabular view of stage/style-specific tasks{' '}
											</span>
											for better visibility and tracking.
											<br />
											<br />
											<span className="weight-500 gray_dark_01 font-italic">
												{' '}
												This marks the first complete feature development by the Nitex
												in-house tech team, recognized by the entire Nitex team after
												the launch.{' '}
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					{/* single-note */}
					<div className="notes-single">
						<p className="note-title gray_dark_01 weight-600 pb-2">May 2021 Highlights</p>
						<div className="card">
							<div className="card-body">
								<div className="release-content">
									<ul>
										<li className="gray_dark_01 regular-14 gray_dark_02 remove-dot">
											<span className="weight-500 gray_dark_01 font-italic">
												This marks the beginning of an exciting new chapter for Nitex!
												Starting this month, our in-house technology team takes the
												reins. Before that, we mainly worked with contractual and part
												time developers. The rocket journey starts from here!!
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default ReleaseNotes;
